// External destinations the app links out to.

// The public marketing / landing site. Pack browsing lives there now that the
// in-app gallery (/packsGallery) has been removed.
// - LANDING_URL: site root — the header logo.
// - LANDING_TERMS_URL / LANDING_PRIVACY_URL: the permanent legal pages. These
//   URLs stay the same when the site serving them changes at public launch.
// - LANDING_PACKS_URL: the pack browser — "The Packs" nav + the cart's
//   "See All Packs" button.
// - LANDING_INSTRUMENT_URL / LANDING_SUBSCRIBE_URL: the marketing nav on the
//   auth pages (PublicSiteHeader).
export const LANDING_URL = 'https://www.organicelectronics.io';
export const LANDING_PACKS_URL = `${LANDING_URL}/packs`;
export const LANDING_INSTRUMENT_URL = `${LANDING_URL}/#instrument`;
export const LANDING_SUBSCRIBE_URL = `${LANDING_URL}/subscribe`;
export const LANDING_TERMS_URL = `${LANDING_URL}/terms`;
export const LANDING_PRIVACY_URL = `${LANDING_URL}/privacy`;
